import type { Device } from './Device';

// El estado lo decide el backend (ver Connectivity.ts del backend): una
// estación pasa a "sin conexión" si el broker avisa que se cayó o si deja
// de mandar datos más de lo normal para ella. Acá solo se presenta.
export type Connectivity =
  | { state: 'online'; label: 'En línea' }
  | { state: 'offline'; label: 'Sin conexión'; since: string }
  | { state: 'never'; label: 'Sin datos todavía' };

export function connectivityOf(device: Pick<Device, 'status' | 'lastSeenAt'>): Connectivity {
  if (device.status === 'online') return { state: 'online', label: 'En línea' };
  if (!device.lastSeenAt) return { state: 'never', label: 'Sin datos todavía' };
  return { state: 'offline', label: 'Sin conexión', since: device.lastSeenAt };
}

// "las 09:12", "ayer a las 22:40", "el 28/09 a las 14:05".
export function formatSince(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const time = d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', hour12: false });
  const day = (x: Date) => x.toDateString();
  if (day(d) === day(now)) return `las ${time}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (day(d) === day(yesterday)) return `ayer a las ${time}`;
  return `el ${d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit' })} a las ${time}`;
}
